export default function () {
   class Accordion {
      constructor(heading) {
         this.heading = heading
      }

      hideAllClickedOutside() {
         const accordion = document.querySelectorAll( '.accordion' );
         const accordionHeading = document.querySelectorAll( this.heading );
         

         function hideElement( e ){
            $( document ).mouseup( function( e ) {
               var container = $( '.accordion' );

               // if the target of the click isn't the container nor a descendant of the container
               if ( !container.is( e.target )
                     && container.has( e.target ).length === 0
                     && e.clientX <= document.documentElement.offsetWidth
                  ) 
               {
                  accordionHeading.forEach( element => {
                     element.classList.contains( 'active' ) ? 
                        element.classList.remove( 'active' ) : null;
                  });
               }
            });
         }

         document.addEventListener( 'click', hideElement, false );
      }

      showOne() {
         const accordionHeading = document.querySelectorAll(this.heading);
         
         accordionHeading.forEach((item, key) => {
            item.addEventListener('click', () => {
               // accordionHeading.forEach(element => {
               //    element.classList.contains('active') ? 
               //       element.classList.remove('active') : null;
               // });
               
               item.classList.contains('active') ? item.classList.remove('active') : item.classList.add('active');
               //item.classList.add('active');
            });
         });
      }

      showAll() {
         const accordionHeading = document.querySelectorAll(this.heading);
         
         accordionHeading.forEach((item, key) => {
            item.addEventListener('click', () => { 
               item.classList.contains('active') ? 
                  item.classList.remove('active') :            
                  item.classList.add('active');
            });
         });
      }
   }

   const accordion = new Accordion('.accordion__title');
   // for open every use showAll();
   accordion.showOne();
   accordion.hideAllClickedOutside();
}

